
import ManageTags from "@/components/DashboardModals/manageTags";
import draggable from "vuedraggable";
import ProgressTask from "@/components/widgets/Progress-task";
import SimpleCard from "@/components/widgets/Simple-card";
import TableCard from "@/components/widgets/Table-card";
import { dashboardMutations, dashboardGetters } from "@/store/helpers";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
export default {
  props: {
    step: String,
    aggregationTypes: Array,
    modalKey: String,
  },
  data() {
    return {
      selectedOperator: null,
      selectedFilter: null,
      filteringOptions: [],
      operators: [],
      tasks: [],
      isAlert: false,
      selectedAggOption: "none",
      hasAggregation: false,
      allFields: [],
      selectedFields: [],
      tileForm: [
        { key: "table", display_name: "Table", aggTypes: ["none"] },
        {
          key: "number",
          display_name: "Number",
          aggTypes: ["count", "average", "maximum", "minimum"],
        },
        {
          key: "percentage",
          display_name: "Percentage",
          aggTypes: ["percentage"],
        },
      ],
      filteredTileForm: [],
      selectedTile: null,
      alertMessage: null,
    };
  },
  async created() {
    let getConfigs = await this.$axios.get(
      `${localStorage.getItem("organizationId")}/advanced-queries/configs`
    );
    this.allFields = getConfigs.data.data.allowed_fields;
    this.operators = getConfigs.data.data.operators;
    this.filteringOptions = getConfigs.data.data.allowed_filters.map((e) => ({
      ...e,
      operator: e.operator ? e.operator : this.operators[0],
      text: e.display_name,
      value: null,
    }));
    this.tasks.push({ field: null, operator: { value: null } });
  },
  computed: {
    ...dashboardGetters,
    currentCard() {
      return this.getCurrentCard();
    },
  },
  watch: {
    tasks: {
      deep: true,
      immediate: true,
      handler(val) {
        this.$emit("selectedFilters", val);
      },
    },
    step(val) {
      if (val == "filtering") {
        let rules = this.currentCard.query.filters.rules; //.map(rule => rule.field)
        this.tasks = this.filteringOptions
          .map((option) =>
            rules.map((e) => e.field).includes(option.field)
              ? {
                  ...option,
                  operator: this.operators.find(
                    (operator) =>
                      operator.value ==
                      rules.find((rule) => rule.field == option.field).operator
                  ),
                  value: rules.find((rule) => rule.field == option.field).value,
                }
              : option
          )
          .filter((e) => e.value);
      }
      if (val == "selection") {
        let rules = this.tasks.map((task) => ({
          field: task.field,
          operator: task.operator.value,
          value: Array.isArray(task.value)
            ? task.value.map((e) => e.value)
            : task.value.value
            ? task.value.value
            : task.value,
        }));
        this.SET_CURRENT_CARD({ rules: rules });
      }
    },
  },
  methods: {
    ...dashboardMutations,
    changeFilter(event, i) {
      if (this.tasks.length && this.tasks.some((e) => e.field == event.field)) {
        this.showAlert("This filter already exists!");
      }
      this.filteringOptions = this.filteringOptions
        .map((e) => (e.field == "coordinator_id" ? { ...e, values: [] } : e))
        .map((e) =>
          e.field == event.field || e.display_name == event.display_name
            ? { ...e, selected: true }
            : { ...e, selected: false }
        );
      this.tasks = this.tasks.map((task, taskIndex) =>
        !task.field ||
        (this.filteringOptions.some(
          (e) => e.selected && e.field == event.field
        ) &&
          taskIndex == i)
          ? this.filteringOptions.find((e) => e.selected)
          : task
      );
      this.selectedFilter = this.filteringOptions.find(
        (e) => e.field == event.field
      ).field;
    },
    showAlert(event) {
      this.isAlert = true;
      this.alertMessage = event ? event : null;
      setTimeout(() => (this.isAlert = false), 2000);
    },
    addField(event) {
      if (event == "all") {
        this.selectedFields = [
          ...new Set([...this.selectedFields, ...this.allFields]),
        ];
        this.allFields = [];
      }
      this.selectedFields.push(event);
      this.allFields = this.allFields.filter((e) => e.field != event.field);
      this.SET_CURRENT_CARD({
        fields: this.selectedFields.map((field) => field.field),
      });
      this.$emit(
        "addedFields",
        this.selectedFields.map((field) => field.field)
      );
      // this.payload.fields = this.selectedFields.map(field => field.key)
      // this.SET_CURRENT_CARD(this.payload)
    },
    removeField(event) {
      if (event == "all") {
        this.allFields = [
          ...new Set([...this.allFields, ...this.selectedFields]),
        ];
        this.selectedFields = [];
        return;
      }
      let selectedField = this.selectedFields.find((e) => e.field == event);
      this.allFields.push(selectedField);
      this.selectedFields = this.selectedFields.filter((e) => e.field != event);
      this.$emit("removedFields", this.selectedFields);
    },
    // getTableTitle(event) {
    //   this.payload.title = event
    //   this.SET_CURRENT_CARD(this.payload)
    // },
    selectedTags(val) {
      this.$emit("selectedTags", val);
    },
    changeOperator(event) {
      let changedOperator = this.operators.find((e) => e.text == event.text);
      this.tasks = this.tasks.map((option) =>
        option.field == this.selectedFilter
          ? { ...option, operator: changedOperator }
          : option
      );
    },
    async getCareManagers(task, value) {
      if (task.field != "coordinator_id" || value.length < 3) return;
      let result = await this.$axios.get(
        `${localStorage.getItem("organizationId")}${
          task.endpoint
        }?search=${value}`
      );
      this.tasks = this.tasks.map((option) =>
        option.field == task.field
          ? {
              ...option,
              values: result.data.data.map((e) => ({
                ...e,
                value: e.display_name,
              })),
            }
          : option
      );
    },
    removeSelected(event) {
      this.tasks = this.tasks.filter((e, index) => index != event);
    },
  },
  components: {
    ManageTags,
    draggable,
    Multiselect,
  },
};
